import { createContext, useCallback, useState } from 'react';

const DEFAULT_PRODUCT = null;

interface DefaultContextEcomProduct {
  productList: any;
  updateProductList: (data: any) => void;
}

const DEFAULT_CONTEXT: DefaultContextEcomProduct = {
  productList: DEFAULT_PRODUCT,
  updateProductList: (data: any) => {},
};

export const EcomProductContext = createContext(DEFAULT_CONTEXT);

export function useEcomProductContext(): DefaultContextEcomProduct {
  const [productList, setProductList] = useState(DEFAULT_PRODUCT);
  const updateProductList = useCallback((data): void => {
    setProductList(data);
  }, []);

  return {
    productList,
    updateProductList,
  };
}
